export const options = {
  paging: true,
  select: true,
  autoWidth: true,
  serverSide: false,
  processing: true,
  scrollX: true,
  fixedColumns: {
    start: 1,
  },
  order: [],
  columnDefs: [{ targets: "_all", orderable: true }],
  lengthMenu: [10, 20, 40, 80, 160, 200],
  pagingType: "simple_numbers",
  language: {
    lengthMenu: "Show _MENU_ entries",
    paginate: {
      next: "Next",
      previous: "Previous",
    },
    info: "Showing _START_ to _END_ of _TOTAL_ entries",
  },
  dom:
    "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
    "<'row'<'col-sm-12'B>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
  buttons: [
    {
      text: "Select All",
      action: function (_, dt) {
        dt.rows().select();
      },
    },
    {
      text: "Deselect All",
      action: function (_, dt) {
        dt.rows().deselect();
      },
    },
    {
      extend: "csvHtml5",
      text: "CSV",
      title: "Course KPIs",
      exportOptions: {
        columns: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ],
      },
      customizeData: (data) => {
        const dt = this;
        const selectedRows = dt.rows({ selected: true }).data().toArray();
        if (selectedRows.length > 0) {
          data.body = selectedRows.map((row) => Object.values(row));
        } else {
          const allRows = dt.rows().data().toArray();
          data.body = allRows.map((row) => Object.values(row));
        }
      },
    },
  ],
};

export const columns = [
  { title: "Course ID", data: "course_id", visible: false },
  {
    title: "Course Name",
    data: "course_name",
    className: "fixed-column-devices-table-bg",
  },
  { title: "App Enabled", data: "app_enabled" },
  { title: "All Rounds", data: "primary_rounds" },
  { title: "Primary Tracked", data: "rounds_tracked" },
  { title: "Dashboard views", data: "dashboard_views" },
  { title: "# Delayers", data: "delayers" },
  { title: "Marshal Notes", data: "marshal_notes" },
  { title: "Days used", data: "day_used" },
  { title: "Days assigned", data: "days_assigned" },
  { title: "Complete", data: "complete" },
  { title: "% Days assigned", data: "days_assigned_perc" },
  { title: "% On Pace", data: "on_pace" },
  { title: "% Off Pace", data: "off_pace" },
  { title: "% Incomplete", data: "incomplete_perc" },
  { title: "AVG Goaltime", data: "avg_goaltime" },
  { title: "AVG Playtime", data: "avg_playtime" },
  { title: "Tags", data: "tags" },
  { title: "Carts", data: "carts" },
];
